import useFetchObjects from "../../api/useFetchObjects";

const useBestSellers = () => {
  // Get token from localStorage
  const token = localStorage.getItem("token");

  return useFetchObjects(
    ["best-sellers"],
    "books/best_sellers/",
    token ? token : null,
    { refetchOnWindowFocus: false },
  );
};

export default useBestSellers;
